import imgElyon91 from "./elyon9 (1).png";
import imgElyon92 from "./elyon9 (2).png";
import imgElyon93 from "./elyon9 (3).png";
import imgElyon94 from "./elyon9 (4).png";
import imgElyon95 from "./elyon9 (5).png";

const imgElyon9 = [imgElyon91, imgElyon92, imgElyon93, imgElyon94, imgElyon95];

export default imgElyon9;
